const meta = {
  annotations: 'Annotations',
  namespaces: 'Namespaces',
  'resource-labels': 'Resource labels',
  sidecars: 'Sidecars',
  tolerations: 'Tolerations',
};

export default meta;
